export default __webpack_public_path__ + "static/media/polygon-icon.97ff139c.svg";